import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'itcRegions',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.itcRegions.endpoint,
        instanceEndpoint:   endpoints.itcRegions.instanceEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, 'ITCONIC').map(item => ({
            ...item,
            fullLabel: `${item.title} [${item.code}]`
        }))
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/itcRegions.js